import { 
	RichText, 
	MediaUploadCheck,
    MediaUpload,
	InspectorControls,
 } from '@wordpress/block-editor';
 import { 
	Button, 
	ButtonGroup,
	Panel, 
	PanelBody, 
	Placeholder,
	TextareaControl,
} from '@wordpress/components';

import { 
	image, 
	trash, 
	update, 
	pullLeft, 
	pullRight 
} from '@wordpress/icons';

import { __ } from '@wordpress/i18n';



const Edit = ( { attributes, setAttributes } ) => {

	const {
		imageSrc,
		altText,
		headline,
		description,
		mediaPosition,

	} = attributes;


	const isLeft = mediaPosition === 'left';
	const ALLOWED_MEDIA_TYPES = [ 'image' ];

	const imageInspectorControls = <div>
		<InspectorControls>
			<Panel>
				<PanelBody
					title={__('Bild Einstellungen', 'ssvreutlingen')}
				>
					<TextareaControl
						value={altText}
						label={__('Alt Text für Bild', 'ssvreutlinghen')}
						onChange={(value) => setAttributes({ altText: value })} />
				</PanelBody>
				<PanelBody
					title={__('Bild Ausrichtung', 'ssvreutlingen')}
				>

						<ButtonGroup>
							<Button 

								icon={ pullLeft }
								label={ __( 'Bild zur linken Seite', 'ssvreutlingen' ) }
								isPressed={ mediaPosition === 'left' }
								onClick={ () => setAttributes( { mediaPosition: 'left' } ) }
							/>
							<Button 
								icon={ pullRight }
								label={ __( 'Bild zur rechten Seite', 'ssvreutlingen' ) }
								isPressed={ mediaPosition === 'right' }
								onClick={ () => setAttributes( { mediaPosition: 'right' } ) }
							/>
						</ButtonGroup>		
					
				</PanelBody>
			</Panel>
		</InspectorControls>
	</div>;

	const textContent = <div>
		<RichText
			tagName="h3"
			value={ headline }
			onChange={ ( headline ) => setAttributes( { headline } ) }
			placeholder={ __( 'Überschrift', 'ssvreutlingen' ) }
		/>
		<RichText
			tagName="p"
			value={ description }
			onChange={ ( description ) => setAttributes( { description } ) }
			placeholder={ __( 'Überschrift', 'ssvreutlingen' ) }
		/>
	</div>;
	const imageContent = <div>
		<MediaUploadCheck>
			<MediaUpload
				icon={ image }
				title={ __( 'Bild auswählen/hochladen', 'ssvreutlingen') } 
				multiple={false}
				value={imageSrc ? imageSrc.id : ''}
				onSelect={imageSrc => setAttributes({ imageSrc: imageSrc })}
				allowedTypes={ ALLOWED_MEDIA_TYPES }
				render={ ({ open }) => (
					
					imageSrc ? 
						<div>
							<img src={imageSrc.url} className='page__content-image-img' />
							<ButtonGroup>
								<Button 
									icon={ update } 
									onClick={ open } 
									className='is-secondary' 
									iconSize='20' 
								> 
									{ __( 'Bild austauschen','ssvreutlingen' ) }
								</Button>
								<Button 
									icon={ trash } 
									onClick={() => setAttributes({ imageSrc: '' })} 
									className='is-secondary' 
									showTooltip='true' 
									iconSize='20'
									label={ __( 'Entfernen','ssvreutlingen' ) }
								> 
									
								</Button>
							</ButtonGroup>
						</div>
					: 
						<div>
							<Placeholder 
								icon={ image }  
								label={ __( 'Bild','ssvreutlingen' ) }
								className='is-large'
							>
								<p>{ __( 'Wähle ein Bild und vergesse bitte nicht die richtige Postion. (Immer im Wechsel bei mehreren Text-Bild-Elementen )','ssvreutlingen' ) }</p>
								<Button 
									icon={ image } 
									onClick={open} 
									className='is-primary'
								>
									{ __( 'Bild auswählen','ssvreutlingen' ) } 
								</Button>
							</Placeholder>
					</div>
					
				
				)}
				
			/>
		</MediaUploadCheck>			
	</div>;

	return (

		

		<div className='textimage'>
			{ isLeft ?
				<div className='wp-block-columns is-layout-flex'>
					<div className='wp-block-column'>
						{imageContent}
					</div>
					<div className='wp-block-column'>
						{textContent}
					</div>
				</div>	
				:
				<div className='wp-block-columns is-layout-flex'>
					<div className='wp-block-column'>
						{textContent}
					</div>
					<div className='wp-block-column'>
						{imageContent}
					</div>
				</div>
			}
			{imageInspectorControls}
		</div>
	)
};
export default Edit;
